import { LandingPage } from "../landing/LandingPage";
import { mountPage } from "./mountPage";

mountPage("landing-root", <LandingPage />);
